// Pocket FM vocabulary on top of the LFP data model.
// The API and database keep their football names (matches, matchday, Live/Highlight/Google);
// everything the user sees should come from here.

// matchlinks.type -> label
export const CONTENT_TYPES = [
  { value: 'Live', label: 'Full Audio', short: 'Full Audio' },
  { value: 'Highlight', label: 'Clips & Excerpts', short: 'Clips' },
  { value: 'Google', label: 'Search Engines', short: 'Search' },
]

export const contentTypeLabel = (value) => CONTENT_TYPES.find((t) => t.value === value)?.label || value

// matches.status
export const WORK_STATUSES = ['Monitoring', 'Paused', 'Under Review', 'Closed']

// matches.matchday holds the reporting period; suggestions for the Work form
export const currentPeriodLabel = (date = new Date()) => {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  return `Week ${Math.ceil(((d - yearStart) / 86400000 + 1) / 7)}`
}

// Natural order, so 'Week 9' comes before 'Week 10'
export const sortPeriods = (periods, getValue = (p) => p) =>
  [...periods].sort((a, b) => String(getValue(a)).localeCompare(String(getValue(b)), undefined, { numeric: true }))

export const LANGUAGES = ['English', 'Hindi', 'Tamil', 'Telugu', 'Bengali', 'Marathi', 'Kannada', 'Malayalam', 'Other']

// allow_listed_accounts.tag
export const ALLOWLIST_TAGS = [
  { value: 'official channel', label: 'Official channel' },
  { value: 'author-narrator', label: 'Author / narrator' },
  { value: 'licensed partner', label: 'Licensed partner' },
  { value: 'influencer', label: 'Influencer' },
]

// matchdaydata columns keep LFP's platform names; this is what each one counts for Pocket FM
export const PERIOD_METRICS = [
  { key: 'accnotifiedtwitter', state: 'twitterNotified', platform: 'YouTube', label: 'YouTube channels notified' },
  { key: 'accsuspendedtwitter', state: 'twitterSuspended', platform: 'YouTube', label: 'YouTube channels terminated' },
  { key: 'accnotifiedtiktok', state: 'tiktokNotified', platform: 'Spotify', label: 'Spotify shows reported' },
  { key: 'accsuspendedtiktok', state: 'tiktokSuspended', platform: 'Spotify', label: 'Spotify shows removed' },
  { key: 'accnotifiedtelegram', state: 'telegramNotified', platform: 'Telegram', label: 'Telegram channels notified' },
  { key: 'accsuspendedtelegram', state: 'telegramSuspended', platform: 'Telegram', label: 'Telegram channels removed' },
  { key: 'accnonsuspendedtelegram', state: 'telegramNonSuspended', platform: 'Telegram', label: 'Telegram channels still active' },
  { key: 'membersinspactedtelegram', state: 'telegramImpacted', platform: 'Telegram', label: 'Telegram subscribers impacted' },
  { key: 'accsuspendeddiscord', state: 'discordSuspended', platform: 'File Storage', label: 'File-storage links disabled' },
  { key: 'accnotifiedsnapchat', state: 'snapchatNotified', platform: 'Social', label: 'Social accounts notified' },
]

export const periodMetricLabel = (key) => PERIOD_METRICS.find((m) => m.key === key || m.state === key)?.label || key

// Platform name in linkwebsites for direct file-storage links (LFP called it 'DDL')
export const FILE_STORAGE_PLATFORM = 'File Storage'
// Search engines are reported separately from the other platforms
export const SEARCH_PLATFORMS = ['Google', 'Bing']
